export default "__VITE_ASSET__DgPcqKJK__"